<template>
  <div
    class="badge-wrapper"
    @click="navigateTo('/')"
  >
    <div class="badge">
      <div class="glow" />
      <svg
        class="house"
        fill="none"
        height="31"
        viewBox="0 0 36 31"
        width="36"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M32.1272 17.2636H36.1572V14.4064L18.1037 0L0 14.4064V17.2636H4.02374V30.7336H14.0611V21.1293H22.096V30.7336H32.1899L32.1272 17.2636Z"
          fill="white"
        />
      </svg>
    </div>
    <div class="spacer" />
  </div>
</template>

<style scoped lang="scss">
.badge-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  cursor: pointer;
  z-index: 2;
}

.badge {
  position: absolute;
  // top calculated to align badge center with center-bump center:
  // center-bump center = 17px from bar-bg top
  // badge-wrapper top  = 14px from bar-bg top (flex centered in 58px area)
  // badge top = 17 - 14 - 31 = -28px
  top: -26px;
  width: 62px;
  height: 62px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(
    ellipse 120% 150% at 40% -15%,
    #5b9fff 0%,
    #1554d4 100%
  );
  box-shadow: 0 4px 24px rgba(21, 84, 212, 0.65);

  .glow {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    box-shadow: inset 0 4px 12px rgba(255, 255, 255, 0.3);
  }

  .house {
    position: relative;
    margin-bottom: 6px;
    z-index: 1;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.25));
  }
}

.spacer {
  width: 62px;
  height: 30px;
}
</style>
